import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * Controls the open/closed state of the Fechamento de Caixa screen (US #61506).
 *
 * An OVERLAY — not a route (D-17): no SPA route, no deep link, no history entry. Its ONE entry point is
 * the Fechamento de Caixa button of the Controle de Caixa page header ([OQ-18], D-102 — there is no menu
 * leaf), which opens it through this singleton; `LayoutComponent` mounts the modal only while `open$`
 * is `true`, stacked over the Controle de Caixa page.
 *
 * Close-on-nav: the layout host is re-created on every navigation, and an overlay left open would be
 * mounted a second time by the new layout.
 */
@Injectable({
  providedIn: 'root'
})
export class CashClosingModalService {
  private readonly openState$ = new BehaviorSubject<boolean>(false);

  /** Emits the current open state; replays the latest value to new subscribers. */
  readonly open$: Observable<boolean> = this.openState$.asObservable();

  constructor(private readonly router: Router) {
    // Root singleton: the subscription lives for the app lifetime, so there is nothing to unsubscribe.
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => this.close());
  }

  /** Opens the overlay (mounts the modal via the layout host). */
  open(): void {
    this.openState$.next(true);
  }

  /** Closes the overlay (unmounts the modal). No navigation. */
  close(): void {
    this.openState$.next(false);
  }
}
